export const BINGE_SERIES = ["after-school-chaos"];

const key = (slug) => `kahani_binge_${slug}`;

export function loadResume(slug) {
  try {
    return JSON.parse(localStorage.getItem(key(slug)) || "null");
  } catch {
    return null;
  }
}

export function saveResume(slug, chapter, panel) {
  try {
    localStorage.setItem(key(slug), JSON.stringify({ chapter, panel, at: Date.now() }));
  } catch {}
}

export function clearResume(slug) {
  try {
    localStorage.removeItem(key(slug));
  } catch {}
}

export function track(name, params) {
  if (typeof window.gtag === "function") window.gtag("event", name, params);
}
